import ContentGuide from '@/global/guides/ContentGuide'
import {
    FuncionarioCentroCusto,
    centroCustoFuncionario_api,
    funcionario,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { columnsCentroCusto } from 'templates/Cadastro/Funcionarios/constants/columns'

export const FuncionarioCentroCustoDataGrid = () => {
    const employeeId = useStore(state => state.employeeId)
    const {
        data = [],
        refetch,
        isLoading,
    } = funcionario.useFetchByIdFrom<FuncionarioCentroCusto[]>(
        employeeId,
        'centro-custos',
    )

    const { mutate } = centroCustoFuncionario_api.mutations.useUpdate()

    return (
        <div className="h-[16.6rem] w-full">
            <ContentGuide.DataGrid
                loading={isLoading}
                columns={columnsCentroCusto}
                rows={data}
                hideFooter
                density="compact"
                ToolbarProps={{ hideToolbar: true }}
                onCellEditCommit={({ id, field, value }) => {
                    if (['dtInicial', 'dtFinal'].includes(field)) {
                        mutate(
                            {
                                [field]: value || null,
                                id: id as string,
                            } as any,
                            {
                                onSuccess: () => {
                                    toast.success(
                                        `Centro de custo alterado com sucesso`,
                                    )
                                    refetch()
                                },
                                onError: err => {
                                    toast.error(err.message)
                                },
                            },
                        )
                    }
                }}
            />
        </div>
    )
}
